import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

export const PipelinesModelSchema = z
  .object({
    id: z.string(),
    name: z.string().nullish(),
    type: z.string().nullish(),
    default: z.boolean().nullish(),
    default_fund: z.string().nullish(),
    pipeline_warn_days: z.number().nullish(),
    pipeline_warn_colour: z.string().nullish(),
    pipeline_crit_days: z.number().nullish(),
    pipeline_crit_colour: z.string().nullish()
  })
  .strict()

const PipelinesModelFields = makeFieldKeys(PipelinesModelSchema)

export type PipelinesModel = z.infer<typeof PipelinesModelSchema>

function validatePipelinesModel(data: unknown): PipelinesModel {
  try {
    return validateWithZodSchema(PipelinesModelSchema, data, 'pipelines model')
  } catch (error) {
    throw new Error(`Pipelines model validation failed: ${error}`)
  }
}
